import { render, staticRenderFns } from "./ServiceDetailsContent.vue?vue&type=template&id=238ad0f0&scoped=true&"
import script from "./ServiceDetailsContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ServiceDetailsContent.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ServiceDetailsContent.vue?vue&type=style&index=0&id=238ad0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ad0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238ad0f0')) {
      api.createRecord('238ad0f0', component.options)
    } else {
      api.reload('238ad0f0', component.options)
    }
    module.hot.accept("./ServiceDetailsContent.vue?vue&type=template&id=238ad0f0&scoped=true&", function () {
      api.rerender('238ad0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/ServiceDetailsContent.vue"
export default component.exports